/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Dialog_DescriptionInputs */

const en_directory_ads_dialog_description = /** @type {(inputs: Directory_Ads_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose which listing to promote. Payment activates your banner for the selected week immediately.`)
};

const zh_directory_ads_dialog_description = /** @type {(inputs: Directory_Ads_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要推广的产品。付款后横幅在所选周立即生效。`)
};

/**
* | output |
* | --- |
* | "Choose which listing to promote. Payment activates your banner for the selected week immediately." |
*
* @param {Directory_Ads_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_dialog_description = /** @type {((inputs?: Directory_Ads_Dialog_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Dialog_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_dialog_description(inputs)
	return zh_directory_ads_dialog_description(inputs)
});
export { directory_ads_dialog_description as "directory.ads.dialog_description" }